import { useAuth } from "@/components/Auth";
import { Button, PasswordInput, Stack, TextInput } from "@mantine/core";
import { Form, useForm } from "@mantine/form";
import { useEffect } from "react";

const AdminLogin = () => {
    const { adminLogin } = useAuth();
    const form = useForm({
        mode: 'uncontrolled',
        initialValues: {
            email: '',  
            password: ''
        },
        validate: {
            email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
        }
    });
    useEffect(() => {
        document.title = "Admin Login - Guard Dog Real Estate Protection Service";
    }, []);
    return (
        <Form onSubmit={adminLogin} form={form}>
            <Stack mt={20} justify="top" align="center" style={{ height: '100vh' }}>
                <TextInput
                    type='email'
                    data-autofocus
                    style={{ width: '300px' }}
                    label="Email"
                    placeholder="Enter your admin email"
                    key={form.key('email')}
                    {...form.getInputProps('email')}
                />
                <PasswordInput
                    label="Password"
                    placeholder="Enter your password"
                    style={{ width: '300px' }}
                    key={form.key('password')}
                    {...form.getInputProps('password')}
                />
                <Button type="submit" style={{ width: '300px' }}>
                    Login
                </Button>
            </Stack>
        </Form>
    )
}
export default AdminLogin;